(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meller-shapes-collection-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const positionActiveShape = () => {
      if (!window.matchMedia('(max-width: 749px)').matches) return;

      document.querySelectorAll('.meller-shapes-landing__nav').forEach((nav) => {
        const activeShape = nav.querySelector('.meller-shapes-landing__shape[aria-current="page"]');
        if (!activeShape) return;

        const targetLeft = activeShape.offsetLeft - (nav.clientWidth - activeShape.offsetWidth) / 2;
        nav.scrollLeft = Math.max(0, targetLeft);
      });
    };

    const initialize = () => requestAnimationFrame(positionActiveShape);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
